// extracted by mini-css-extract-plugin
export default {"mainContent":"MainContent_mainContent__+Z0Jw","liveScoreImage":"MainContent_liveScoreImage__d2CaE"};